import { Button } from '@/components/form/baseInputs/Button';
import { FileQuestion02Icon } from '@/components/icons/FileQuestion02Icon';
import { useMissingDocumentsContext } from '@/modules/missingDocuments/contexts/MissingDocumentsContext';

export function MissingDocumentsButton() {
  const { isShowing, show, hide, count, loading } =
    useMissingDocumentsContext();

  if (loading || count == 0) return null;

  return (
    <Button
      variant="secondary"
      onClick={isShowing ? hide : show}
      size="sm"
      startIcon={FileQuestion02Icon}
    >
      {count} missing documents identified
    </Button>
  );
}
